module.exports = __webpack_public_path__ + "static/media/U1-T2-2-4.98499507.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-2-4.mp3
// module id = 559
// module chunks = 0